import * as React from 'react';
import { Form, Header, Segment } from 'semantic-ui-react';

import DeTerceros, {
    Datos as DeTercerosDatos,
    inicial as deTercerosInicial,
} from '../../../../DeTerceros';
import Pendiente, {
    Datos as PendienteDatos,
    inicial as pendienteInicial,
} from '../../../componentes/Pendiente';
import FechaPago, { Datos as FechaPagoDatos, inicial as fechaPagoInicial } from './FechaPago';
import PresentaAbonoInicial from './PresentaAbonoInicial';

export interface Datos {
    pendiente: PendienteDatos;
    numeroDeCheques: number;
    fechaPago: FechaPagoDatos;
    deTerceros: DeTercerosDatos;
    presentaAbonoInicial: boolean;
}

export const inicial: Datos = {
    pendiente: { ...pendienteInicial },
    numeroDeCheques: 10,
    fechaPago: { ...fechaPagoInicial },
    deTerceros: { ...deTercerosInicial },
    presentaAbonoInicial: false,
};

interface Props {
    cheque: Datos;
    onChange(cheque: Datos): void;
}

class Cheque extends React.Component<Props> {
    private readonly cuotas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    private readonly cuotasOptions = this.cuotas.map(numero => ({
        key: numero,
        value: numero,
        text: numero.toString(),
    }));

    public render() {
        const { cheque, onChange } = this.props;

        return (
            <div>
                <Header as='h3'>Cheque</Header>

                <Pendiente
                    ancho='4'
                    datos={cheque.pendiente}
                    onChange={pendiente => {
                        onChange({ ...cheque, pendiente });
                    }}
                />

                <Segment>
                    <Form.Group widths='2'>
                        <Form.Select
                            label='N° de cheques'
                            placeholder='Seleccione'
                            options={this.cuotasOptions}
                            value={cheque.numeroDeCheques}
                            onChange={(_e, { value }) => {
                                onChange({ ...cheque, numeroDeCheques: value as number });
                            }}
                        />
                    </Form.Group>
                    <FechaPago
                        fechaPago={cheque.fechaPago}
                        onChange={fechaPago => {
                            onChange({ ...cheque, fechaPago });
                        }}
                    />
                    <DeTerceros
                        etiquetaCheckbox='Cheque de terceros'
                        etiquetaInput='Titular del cheque'
                        valor={cheque.deTerceros}
                        onChange={deTerceros => {
                            onChange({ ...cheque, deTerceros });
                        }}
                    />
                    <PresentaAbonoInicial
                        presentaAbono={cheque.presentaAbonoInicial}
                        onChange={presentaAbonoInicial => {
                            onChange({ ...cheque, presentaAbonoInicial });
                        }}
                    />
                </Segment>
            </div>
        );
    }
}

export default Cheque;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/componentes/Cheque.tsx